module.exports = __webpack_public_path__ + "img/SWP_Hammer_2H_02 (1).cfa1e25d.png";